import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button as DSButton } from './Button'; 
import { Logo } from './Logo';
import '../../../pages/Home/Home.css';

export const Navbar = ({ showLogin = true, showGetStarted = true }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <nav className="lp-nav">
            <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Logo />
            </div>

            {/* Desktop Menu */}
            <div className="nav-links">
                <Link to="/SuccessPage" className="nav-link">Success Stories</Link>
                <Link to="/aboutus" className="nav-link">About Us</Link>
                <a href="https://mytamildate.com/blog/" className="nav-link" target="_blank" rel="noopener noreferrer">Blogs</a>
                <Link to="/contactus" className="nav-link">Contact Us</Link>
            </div>

            <div className="lp-desktop-only">
                {showLogin && (
                    <DSButton
                        to="/login"
                        variant="ghost"
                        size="sm"
                        className="hover:text-primary transition-colors"
                        style={{ textDecoration: 'none', color: '#111' }}
                    >
                        Login
                    </DSButton>
                )}
                {showGetStarted && (
                    <DSButton to="/signup" variant="primary">
                        Get Started
                    </DSButton>
                )}
            </div>

            {/* Mobile Actions: Login + Menu */}
            <div className="lp-mobile-only">
                {showLogin && (
                    <DSButton
                        to="/signinoptions"
                        variant="primary"
                        size="sm"
                        style={{ fontSize: '0.8rem' }}
                    >
                        Login
                    </DSButton>
                )}
                <button className="mobile-menu-btn" onClick={() => setIsMenuOpen(!isMenuOpen)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'block' }}>
                    <span className="material-symbols-outlined lp-text-2xl">menu</span>
                </button>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="mobile-menu md:hidden">
                    <Link to="/success_stories" className="nav-link block p-2" onClick={toggleMenu}>Success Stories</Link>
                    <Link to="/aboutus" className="nav-link block p-2" onClick={toggleMenu}>About Us</Link>
                    <a href="https://mytamildate.com/blog/" className="nav-link block p-2" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>Blogs</a>
                    <Link to="/contactus" className="nav-link block p-2" onClick={toggleMenu}>Contact Us</Link>
                </div>
            )}
        </nav>
    );
};
